import { render, staticRenderFns } from "./DoctorCertificationModal__Style#Drawer.vue?vue&type=template&id=52200beb&scoped=true&"
import script from "./DoctorCertificationModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./DoctorCertificationModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./DoctorCertificationModal__Style#Drawer.vue?vue&type=style&index=0&id=52200beb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52200beb",
  null
  
)

export default component.exports